module.exports = __webpack_public_path__ + "img/HKK_3_0.a74b7ec0.png";